export enum emitNames {
    onScroll='onScroll',
    onScrollLower='onScrollLower',
    onScrollUpper='onScrollUpper'
}
